// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"7f8db88a","425":"e8d32f23","510":"08c7a9ed","532":"414d80e7","633":"ca9b559d","634":"0b348313","922":"d6975528","937":"0e919128","972":"84a8959d"}[chunkId] + ".chunk.js";
};